import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';
import { SvgChevronDownSingle } from '../__generated__/icons/SvgChevronDownSingle.js';
import { mergeThemes } from '../utils/themes.js';
import { accordionRow, noJsInput, noJsButton, labelText, toggle, chevronIconDown, toggleIconWithLabel, toggleLabel, chevronIconUp, collapsedBody } from './styles.js';
import { transformProviderTheme, themeAccordion } from './theme.js';
import { visuallyHidden as visuallyHidden$1 } from '../../foundations/accessibility/visually-hidden.js';
const visuallyHidden = css `
	${visuallyHidden$1}
`;
const AccordionRowNoJS = ({ label, hideToggleLabel = false, children, cssOverrides, theme, ...props }) => {
    const mergedTheme = (providerTheme) => mergeThemes(themeAccordion, theme, providerTheme, transformProviderTheme);
    return /* @__PURE__ */ jsx("div", {
        css: (providerTheme) => [
            accordionRow(mergedTheme(providerTheme.accordion)),
            cssOverrides
        ],
        ...props,
        children: /* @__PURE__ */ jsxs("label", { children: [
                /* @__PURE__ */ jsx("input", {
                    type: "checkbox",
                    css: (providerTheme) => noJsInput(mergedTheme(providerTheme.accordion)),
                    role: "button"
                }),
                /* @__PURE__ */ jsxs("div", {
                    css: (providerTheme) => noJsButton(mergedTheme(providerTheme.accordion)),
                    "data-target": "label",
                    children: [
                        /* @__PURE__ */ jsx("strong", { css: labelText, children: label }),
                        /* @__PURE__ */ jsxs("div", { "data-target": "toggle", children: [
                                /* @__PURE__ */ jsxs("div", {
                                    css: [
                                        toggle,
                                        chevronIconDown,
                                        !hideToggleLabel ? toggleIconWithLabel : ""
                                    ],
                                    "data-target": "toggle-label-show",
                                    children: [
                                        /* @__PURE__ */ jsxs("span", {
                                            css: (providerTheme) => [
                                                toggleLabel(mergedTheme(providerTheme.accordion)),
                                                hideToggleLabel ? visuallyHidden : ""
                                            ],
                                            children: [
                                                "Show",
                                                /* @__PURE__ */ jsx("span", { css: visuallyHidden, children: " more" })
                                            ]
                                        }),
                                        /* @__PURE__ */ jsx(SvgChevronDownSingle, { theme: { fill: theme?.iconFill } })
                                    ]
                                }),
                                /* @__PURE__ */ jsxs("div", {
                                    css: [
                                        toggle,
                                        chevronIconUp,
                                        !hideToggleLabel ? toggleIconWithLabel : ""
                                    ],
                                    "data-target": "toggle-label-hide",
                                    children: [
                                        /* @__PURE__ */ jsx("span", {
                                            css: (providerTheme) => [
                                                toggleLabel(mergedTheme(providerTheme.accordion)),
                                                hideToggleLabel ? visuallyHidden : ""
                                            ],
                                            children: "Hide"
                                        }),
                                        /* @__PURE__ */ jsx(SvgChevronDownSingle, { theme: { fill: theme?.iconFill } })
                                    ]
                                })
                            ] })
                    ]
                }),
                /* @__PURE__ */ jsx("div", { css: collapsedBody, "data-target": "body", children: /* @__PURE__ */ jsx("div", { children }) })
            ] })
    });
};
export { AccordionRowNoJS };
